import { render, staticRenderFns } from "./BlockType5.vue?vue&type=template&id=fc0c09a0&scoped=true&"
import script from "./BlockType5.vue?vue&type=script&lang=ts&"
export * from "./BlockType5.vue?vue&type=script&lang=ts&"
import style0 from "./BlockType5.vue?vue&type=style&index=0&id=fc0c09a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0c09a0",
  null
  
)

export default component.exports